import config from '@/config/index.js';

/**
 * 获取落地页配置
 * @param {object} param
 * @param {string} param.lpid
 * @param {string} [param.mode]
 */
const getLandPageConfig = {
    url: '/beyonder/api/v1/landing-pages/{lpid}',
    method: 'get'
};

// 试驾单
const createTestDriveOrders = {
    url: '/beyonder/api/v3/test-drive-orders/by-mobile-verify',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const createLeads = {
    url: `/beyonder/api/v3/leads/by-mobile-verify`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 登录用户留资
const createLeadsByLoginUser = {
    url: '/beyonder/api/v2/leads/by-login-user',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 登录用户创建试驾单
const createTestDriveOrdersByLoginUser = {
    url: '/beyonder/api/v2/test-drive-orders/by-login-user',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const decideGuidePage = {
    url: `/beyonder/api/v1/guide-pages/decide`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const wxConfigSig = {
    url: `/index/wxConfigSig`,
    method: 'get'
};

// 落地页 任务组件 获取任务详情
const getTaskDetail = {
    url: `/beyonder/api/v1/landing-pages/task/detail`,
    method: 'get'
};

// 落地页 任务组件 任务参与校验
const checkTaskParticipation = {
    url: '/beyonder/api/v1/landing-pages/task/check-participation',
    method: 'get'
};

// 落地页 任务组件 领取奖励
const receiveTaskRewards = {
    url: '/beyonder/api/v1/landing-pages/task/receive-award',
    method: 'post',
    requstTypeJson: true
};

// 落地页 领奖打卡组件 配置
const getAwardCompConfig = {
    url: '/beyonder/api/v1/landing-pages/award/config',
    method: 'get'
};

// 落地页 领奖打卡组件 场所位置信息 by 距离判断维度
const getAwardCompTargetLocation = {
    url: '/beyonder/api/v1/landing-pages/award/target-location',
    method: 'get'
};

// 落地页 领奖打卡组件 获取奖励详情及参与情况
const getAwardCompAwardsDetail = {
    url: '/beyonder/api/v1/landing-pages/award/awards-detail',
    method: 'get'
};

// 落地页 领奖打卡组件 用户是否可参与
const getAwardCompUserParticipation = {
    url: '/beyonder/api/v1/landing-pages/award/user-participation',
    method: 'get'
};

// 落地页 领奖打卡组件 发放奖励
const awardCompReceiveAwards = {
    url: '/beyonder/api/v1/landing-pages/award/issue-award',
    method: 'post',
    requstTypeJson: true
};

// 落地页 领奖打卡组件 发放奖励
const issueAwardAfterLeads = {
    url: '/beyonder/api/v1/landing-pages/award/leads-issue-award',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 按钮 加入群聊 生成入群口令
const encodeGroupChatPassword = {
    url: '/beyonder/api/v1/marketing/group-chat/password/encode',
    method: 'post',
    requstTypeJson: true
};

const landingPageSendVerificationCode = {
    url: '/beyonder/api/v1/landing-pages/verification-code/send',
    method: 'post',
    requstTypeJson: true
};

// 落地页 认证组件 企业用户认证详情
const getCorpUserAuthenticationDetail = {
    url: '/enterprise/v1/user-authenticate',
    method: 'get',
    serverHost: '/dino'
};
// 落地页 认证组件 发送邮箱验证码
const sendCorpUserAuthenticationEmailCaptcha = {
    url: '/enterprise/v1/captcha',
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};
// 落地页 认证组件 提交认证
const submitCorpUserAuthentication = {
    url: '/enterprise/v1/user-authenticate',
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};

// 根据ip获取省市区信息
const getIpArea = {
    url: '/tools/v1/area/by-forwarded-ip',
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

// 逆地址解析(经纬度->地址)
const rgeoDetail = {
    url: `/rgeo/detail`,
    method: 'post',
    requstTypeJson: true,
    serverHost: '/backend'
};

// 获取登录用户信息
const getLoginUserInfo = {
    url: '/beyonder/api/v1/landing-pages/award/user-profile',
    method: 'get'
};

// 获取account
const getAccount = {
    url: `uds/in/user/v2/users/accounts/{account_id}`,
    method: 'get',
    serverHost: '/'
};

// 通过卡券实例ID获取好朋友券活动
const getActivityByCouponIssueId = {
    url: `/beyonder/api/v1/landing-pages/coupons/activity`,
    method: 'get',
    serverHost: '/'
};

// 生成uniqueKey
const generateUniqueKey = {
    url: '/user/v1/referral/unique-key',
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};

/**
 * 获取成功提交页V2的跳转开关结果
 * true：使用新页面
 * https://apidoc.nioint.com/project/11730/interface/api/1460233 
 * */
const checkSwitch2DefaultSuccessPage = {
    url: '/proxy/seige/v2/in/submit-page/switch',
    method: 'get',
    serverHost: '/dino'
};

/**
 * 获取成功提交页V2的跳转开关结果
 * true：使用新页面
 * https://apidoc.nioint.com/project/11730/interface/api/1460233 
 * */
const getGisAreaList = {
    url: '/proxy/seige/v1/gis/area/list',
    method: 'get',
    serverHost: '/dino'
};

export default {
    getIpArea,
    getLandPageConfig,
    createTestDriveOrders,
    createLeads,
    createLeadsByLoginUser,
    createTestDriveOrdersByLoginUser,
    decideGuidePage,
    wxConfigSig,
    getTaskDetail,
    checkTaskParticipation,
    receiveTaskRewards,
    getAwardCompConfig,
    getAwardCompTargetLocation,
    getAwardCompAwardsDetail,
    getAwardCompUserParticipation,
    awardCompReceiveAwards,
    rgeoDetail,
    getLoginUserInfo,
    getAccount,
    issueAwardAfterLeads,
    encodeGroupChatPassword,
    getCorpUserAuthenticationDetail,
    sendCorpUserAuthenticationEmailCaptcha,
    submitCorpUserAuthentication,
    landingPageSendVerificationCode,
    getActivityByCouponIssueId,
    generateUniqueKey,
    checkSwitch2DefaultSuccessPage,
    getGisAreaList
};



// WEBPACK FOOTER //
// ./src/service/marketing/index.js